import { render, staticRenderFns } from "./grid.vue?vue&type=template&id=2bd18b9e&scoped=true&"
import script from "./grid.vue?vue&type=script&lang=js&"
export * from "./grid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd18b9e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bd18b9e')) {
      api.createRecord('2bd18b9e', component.options)
    } else {
      api.reload('2bd18b9e', component.options)
    }
    module.hot.accept("./grid.vue?vue&type=template&id=2bd18b9e&scoped=true&", function () {
      api.rerender('2bd18b9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/sys/grid/grid.vue"
export default component.exports